import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-network-log-viewer',
  templateUrl: './network-log-viewer.component.html',
  styleUrls: ['./network-log-viewer.component.css']
})
export class NetworkLogViewerComponent {
  fileSource: any[] = [];
  pageNo: number = 1;

  constructor(public dialogRef: MatDialogRef<NetworkLogViewerComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    try {
      this.fileSource = JSON.parse(this.data);
      this.fileSource.forEach(el => {
          el.showMore = false;
      });
    } catch (error) {
        console.log("Error parsing JSON:", error);
    }
  }
  trimString(text: any, length: any) {
    return text && text.length > length ?
      text.substring(0, length) + '...' :
      text;
  }


  close() {
    this.dialogRef.close(null);
  }
}
